import { domainMapping } from '../constant/domainMapping'
import { PUBLIC_HOSTS }  from '../constant'
import type { HOSTKEY } from '../constant'
import { KD_CONFIG_KEY } from "../constant/config"
import { isClient, isServer } from '../util'

export function getPrivateHostKey (hostKey: HOSTKEY | Lowercase<HOSTKEY>) {
  return domainMapping.get(PUBLIC_HOSTS[hostKey.toUpperCase()]) || 'kdocs'
}

export function getRelease () {
  if (isClient()) {
    return window[KD_CONFIG_KEY] && window[KD_CONFIG_KEY].release
  } 

  if (isServer()) {
    return global[KD_CONFIG_KEY] && global[KD_CONFIG_KEY].release
  }

  return ''
}

// 判断私有化环境
export function isPrivate () {
  return process.env.KAE_RELEASE === 'oem' || getRelease() === 'oem'
}